export const OptionAdminData = [
    {
        title: "Información Portal",
        icon: "MiPerfilIcon",
        link: "/admin/infoPortal",
        subMenuItems: [],
        key: 1
    },
    {
        title: "Beneficios",
        icon: "MiPerfilIcon",
        link: "/admin/beneficios",
        subMenuItems: [],
        key: 2
    },        
    {
        title: "Mails",
        icon: "MiPerfilIcon",
        link: "/admin/mails",
        subMenuItems: [],
        key: 3
    },
    {
        title: "Telefonos",
        icon: "MiPerfilIcon",
        link: "/admin/telefonos",
        subMenuItems: [],
        key: 4
    },
    {
        title: "Redes",
        icon: "MiPerfilIcon",
        link: "/admin/redesLinks",
        subMenuItems: [],
        key: 5
    },
    {
        title: "Videotutoriales",
        icon: "MiPerfilIcon",
        link: "/admin/videotutoriales",
        subMenuItems: [],
        key: 6
    },
    {
        title: "Msj. verificar busqueda",
        icon: "MiPerfilIcon",
        link: "/admin/msjsVerificaBuscador",
        subMenuItems: [],
        key: 7
    },
    {
        title: "Motivos: Rechazo de Orden",
        icon: "MiPerfilIcon",
        link: "/admin/motivoRechazoOrden",
        subMenuItems: [],
        key: 8
    },
    {
        title: "Centros Clin.Méd.",
        icon: "MiPerfilIcon",
        link: "/admin/centrosClinMed",
        subMenuItems: [],
        key: 10
    },
    {
        title: "Centros RAD",
        icon: "MiPerfilIcon",
        link: "/admin/centrosRadiologia",
        subMenuItems: [],
        key: 11
    },
    {
        title: "Centros ELECT",
        icon: "MiPerfilIcon",
        link: "/admin/centrosElectrocardiograma",
        subMenuItems: [],
        key: 12
    },
    {
        title: "Centros Labo.",
        icon: "MiPerfilIcon",
        link: "/admin/centrosLaboratorio",
        subMenuItems: [],
        key: 13
    },
    {
        title: "Preguntas Atenc.Sin Turno",
        icon: "MiPerfilIcon",
        link: "/admin/preguntasAtencionSinTurno",
        subMenuItems: [],
        key: 14
    },
    {
        title: "Resp. Atenc.Sin Turno",
        icon: "MiPerfilIcon",
        link: "/admin/respuestasAtencionSinTurno",
        subMenuItems: [],
        key: 15
    },    
    {
        title: "Preguntas PCR",
        icon: "MiPerfilIcon",
        link: "/admin/preguntasPCR",
        subMenuItems: [],
        key: 16
    },
    {
        title: "Respuestas PCR",
        icon: "MiPerfilIcon",
        link: "/admin/respuestasPCR",
        subMenuItems: [],
        key: 17
    },
    {
        title: "Home",
        icon: "MiPerfilIcon",
        link: "/admin/autoCheckIn",
        subMenuItems: [],
        key: 18
    }    
]